import { AdditionalPageOptions } from 'app/interfaces/additionalPageOptions';
import { UserInfo } from '../../container/App/interface';
import { UserAssetsProp } from './config';
import { Characteristics } from './interface';

function getCharacteristics(res: any) {
    const userAssets = res.userAssets.filter(
        (item: any) => UserAssetsProp.Product === item.entityType
    );

    const characteristics: Characteristics = userAssets.flatMap((item: any) => item.characteristic);

    const isInternetAdActivated = userAssets.some(
        (item: any) => UserAssetsProp.Internet === item.name && UserAssetsProp.Activated === item.status
    );

    return { characteristics, isInternetAdActivated };
}

function checkFixed(characteristics: Characteristics) {
    return characteristics.some(
        item => UserAssetsProp.Stack === item.name && UserAssetsProp.DSL === item.value
    );
}

function checkVkd(characteristics: Characteristics) {
    const isStackAndCable = characteristics.some(
        item => UserAssetsProp.Stack === item.name && UserAssetsProp.Cable === item.value
    );
    const isSubTypeAndKip = characteristics.some(
        item => UserAssetsProp.SubType === item.name && UserAssetsProp.KIP === item.value
    );

    return isStackAndCable && isSubTypeAndKip;
}

function checkUm(
    characteristics: Characteristics,
    isInternetAdActivated: boolean
) {
    if (isInternetAdActivated) {
        return characteristics.some(
            item => UserAssetsProp.Stack === item.name && UserAssetsProp.UM === item.value
        );
    }

    return false;
}

export function handelUserInfoData(res: any): UserInfo {
    const { characteristics, isInternetAdActivated } = getCharacteristics(res[0]);
    const isFixed = checkFixed(characteristics);
    const isVKD = checkVkd(characteristics);
    const isUM = checkUm(characteristics, isInternetAdActivated);

    return {
        isLogged: true,
        isFixed,
        isVKD,
        isUM,
    };
}
/**
 *
 * @param cmsConfig
 * @param accessSupplier
 * @returns
 */
export function mapFiberWholeBuyConfig(cmsConfig: AdditionalPageOptions, accessSupplier?: string) {
    const supplierType: Record<string, string> = {
        OXGG: 'oxgg',
        DTAG: 'wholebuy',
        DGW: 'wholebuy',
    };

    let currentSupplier = supplierType[accessSupplier as keyof typeof supplierType];

    return (cmsConfig.avcResult as any)[currentSupplier];

}

export function mapFiberWholeBuyPromotionalCardConfig(cmsConfig: AdditionalPageOptions,
    accessSupplier?: string) {
    const supplierType: Record<string, string> = {
        OXGG: 'oxgg',
        DTAG: 'wholebuy',
        DGW: 'wholebuy',
    };

    let currentSupplier = supplierType[accessSupplier as keyof typeof supplierType];

    return (cmsConfig.promotionalCard as any)[currentSupplier];

}
